import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Loader, Dimmer } from 'semantic-ui-react';
import { Mensaje, MensajeSiNo } from '../mensajes';


function TablaAjustesSistema() {

    const txtDescripcion = useRef();
    const btnAcepta = useRef();
    const txtLogo = useRef();
    const txtNombre = useRef();
    const txtRif = useRef();
    const txtVacios = useRef();
    const txtTicket = useRef();
    const txtIdajuste = useRef();
    const txtObser = useRef();

    const [body, setBody] = useState(null);
    const [activaaceptar, setActivaaceptar] = useState(true);
    const [opera, setOpera] = useState(0);
    const [valdescrip, setValdescrip] = useState(true);
    const [activate, setActivate] = useState(false);
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    let op = require('../../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');


    const seleccionarRegistro = (id) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'ajustes';
        let nomid = 'idajuste';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.idajuste > 0) {

                    txtLogo.current.checked = response.data.logo === 'SI' ? true : false;
                    txtRif.current.checked = response.data.rif === 'SI' ? true : false;
                    txtNombre.current.checked = response.data.nombre === 'SI' ? true : false;
                    txtVacios.current.checked = response.data.vacios === 'SI' ? true : false;
                    txtTicket.current.checked = response.data.ticket === 'SI' ? true : false;
                    txtDescripcion.current.value = response.data.descripcion;
                    txtIdajuste.current.value = response.data.idajuste;
                    txtObser.current.value = response.data.observacion;
                    setActivaaceptar(false);

                } else {
                    setActivaaceptar(true);
                }

            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {

            setActivate(false);

        })
    };

    const onGestionar = (op) => (e) => {

        if (op === 1) {
            seleccionarRegistro(1);
            setOpera(2);
            setTimeout(() => txtObser.current.focus(), 300);
        } else if (op === 2) {
            blanquear();
        }

    };

    const onChange = (e) => {
        if (e.target.name === "nombre") {
            if (e.target.checked === true) {
                setValdescrip(true);
                if (e.target.checked === true) {
                    setTimeout(() => txtObser.current.focus(), 300);
                }
            } else {
                setValdescrip(false);
                if (e.target.checked === false) {
                    setTimeout(() => txtDescripcion.current.focus(), 300);
                }
            }
        }
    };

    const blanquear = () => {
        txtLogo.current.checked = false;
        txtRif.current.checked = false;
        txtNombre.current.checked = false;
        txtVacios.current.checked = false;
        txtTicket.current.checked = false;
        txtDescripcion.current.value = "";
        txtIdajuste.current.value = "";
        txtObser.current.value = "";
        setActivaaceptar(true);
        setValdescrip(true);
        setOpera(0);
    }

    const onChangeValidar = () => {
        let sigue = true;
        if (opera === 2) {
            if (txtDescripcion.current.value === "") {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "El Campo Descripción no debe ir Vacio",
                    icono: "informacion",
                });
                txtDescripcion.current.focus();
                sigue = false;
            }
        }

        if (sigue) {
            var ajuste = [];
            ajuste.push({
                idajuste: txtIdajuste.current.value,
                logo: txtLogo.current.checked === true ? 'SI' : 'NO',
                nombre: txtNombre.current.checked === true ? 'SI' : 'NO',
                rif: txtRif.current.checked === true ? 'SI' : 'NO',
                vacios: txtVacios.current.checked === true ? 'SI' : 'NO',
                ticket: txtTicket.current.checked === true ? 'SI' : 'NO',
                descripcion: txtDescripcion.current.value.toUpperCase().trim(),
                observacion: txtObser.current.value.toUpperCase().trim()
            });

            setBody({
                ajuste: ajuste,
            });

            let msg = "";
            if (opera === 1) {
                msg = "Esta Seguro de Registrar estos Datos.";
            } else if (opera === 2) {
                msg = "Esta Seguro de Modificar estos Datos.";
            } else if (opera === 3) {
                msg = "Esta Seguro de Eliminar estos Datos.";
            }

            setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: msg,
                icono: "confirmacion",
            });
        }
    };

    const procesarRegistro = () => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/organizacion/actualizarajustes/${opera}`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (opera === 1) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Creado Correctamente",
                            icono: "exito",
                        });
                    } else if (opera === 2) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Modificado Correctamente",
                            icono: "exito",
                        });
                    } else if (opera === 3) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto: "Registro Eliminado Correctamente",
                            icono: "exito",
                        });
                    }
                    setActivate(false);
                }
            })
            .catch(function (error) {
                let mensaje = "";
                if (error.response === undefined) {
                    mensaje = "Error de Conexion";
                } else {
                    if (
                        error.response.data.message ===
                        'duplicate key value violates unique constraint "ubicacion_key"'
                    ) {
                        mensaje = "Ya existe un Registro Actualmente";
                    } else {
                        mensaje = error.response.data.message;
                    }
                }
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: mensaje,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        procesarRegistro();
    };

    const cerrarModal = () => {
        blanquear();
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    };

    return (
        <div className='container-fluid rounded'>
            <div className='container-fluid'>
                <div className="card">
                    <Dimmer active={activate} inverted>
                        <Loader inverted>cargando...</Loader>
                    </Dimmer>

                    <div className="container">
                        <div className="content" >
                            <div className="container">

                                <div className="col-md-12 row m-0 py-3 d-flex justify-content-between">

                                    <input type='hidden' ref={txtIdajuste} />

                                    <div className="form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2">
                                        <label className="form-check-label col-10" for="flexSwitchCheckDefault1">LOGO:</label>
                                        <input className="form-check-input col-2" disabled={opera === 2 ? false : true} ref={txtLogo} type="checkbox" id="flexSwitchCheckDefault1" />
                                    </div>

                                    <div className="form-check form-switch col-pd-140 row m-0 border-azul rounded px-1 mb-2">
                                        <label className="form-check-label col-10" for="flexSwitchCheckDefault2">NOMBRE:</label>
                                        <input className="form-check-input col-2" disabled={opera === 2 ? false : true} onChange={onChange} name='nombre' ref={txtNombre} type="checkbox" id="flexSwitchCheckDefault2" />
                                    </div>

                                    <div className="form-check form-switch col-pd-120 row m-0 border-azul rounded px-1 mb-2">
                                        <label className="form-check-label col-10" for="flexSwitchCheckDefault3">RIF:</label>
                                        <input className="form-check-input col-2" disabled={opera === 2 ? false : true} ref={txtRif} type="checkbox" id="flexSwitchCheckDefault3" />
                                    </div>

                                    <div className="form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2">
                                        <label className="form-check-label col-10" for="flexSwitchCheckDefault4">VACIOS:</label>
                                        <input className="form-check-input col-2" disabled={opera === 2 ? false : true} ref={txtVacios} type="checkbox" id="flexSwitchCheckDefault4" />
                                    </div>

                                    <div className="form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2">
                                        <label className="form-check-label col-10" for="flexSwitchCheckDefault5">TICKET:</label>
                                        <input className="form-check-input col-2" disabled={opera === 2 ? false : true} ref={txtTicket} type="checkbox" id="flexSwitchCheckDefault5" />
                                    </div>

                                    <div className='col-12 px-0 mb-2'>
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION: </label>
                                            <input autoComplete='off' type="text" ref={txtDescripcion} disabled={valdescrip} placeholder="" className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                        </div>
                                    </div>

                                    <div className='col-12 px-0'>
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">OBSERVACION: </label>
                                            <input autoComplete='off' type="text" ref={txtObser} disabled={opera === 2 ? false : true} placeholder="" className="form-control bg-transparent fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className='col-12 mb-3 row m-0'>
                            <div className='col-12 d-flex justify-content-end'>
                                <button onClick={onGestionar(1)} disabled={activaaceptar === false ? true : false} className="btn btn-sm  btn-warning rounded-pill mx-1"><i className="fa fa-edit"> MODIFICAR</i></button>
                                <button
                                    ref={btnAcepta}
                                    disabled={activaaceptar}
                                    onClick={onChangeValidar}
                                    className="btn btn-sm rounded-pill btn-success mx-1"
                                >
                                    <i className="fas fa-check">
                                        {" "}
                                        ACEPTAR
                                    </i>
                                </button>
                                <button disabled={activaaceptar} onClick={onGestionar(2)} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> CANCELAR</i></button>
                            </div>
                        </div>
                    </div>
                    <Mensaje
                        mensaje={mensaje}
                        onHide={() => {
                            mensaje.titulo === "Exito."
                                ? cerrarModal()
                                : setMensaje({
                                    mostrar: false,
                                    titulo: "",
                                    texto: "",
                                    icono: "",
                                });
                        }}
                    />
                    <MensajeSiNo
                        mensaje={mensajesino}
                        onHideNo={() =>
                            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
                        }
                        onHideSi={handleCloseSi}
                    />
                </div >
            </div>
        </div>
    );

}

export default TablaAjustesSistema;


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaAjuste.js